
import { mapGetters, mapMutations } from 'vuex'
import LoleP from '~/components/text/lole-p'
import SvgFlagCa from '~/assets/icons/flag-ca.svg?inline'
import SvgFlagUs from '~/assets/icons/flag-us.svg?inline'
import SvgFlagEu from '~/assets/icons/flag-eu.svg?inline'
export default {
  components: { LoleP, SvgFlagCa, SvgFlagUs, SvgFlagEu },
  computed: {
    ...mapGetters({
      vxTopBar: 'notification/getTopBar',
    }),
  },
  methods: {
    ...mapMutations({
      vxRemoveTopBarCountry: 'notification/removeTopBarCountry',
    }),
  },
}
